import { Injectable, Injector } from '@angular/core';

import { Adres } from '../dto/adres';
import { CrudService, Filter } from '@mango/core';
import { TypeAdres } from '../enums/type-adres';
import { map } from 'rxjs/operators';
import { Relatie } from '../dto/relatie';

@Injectable({ providedIn: 'root' })
export class AdresService extends CrudService<Adres> {

    constructor(injector: Injector) { super(Adres, injector); }    

    kopieerAdres(adres: Adres) {
        let query: string = `api/dto/adres/kopieer?adresId=${adres.id}`;

        return this.http.post(query, null).pipe(map(x => x as AdresResponse));

    }  

    getRelatieFilter(relatie: Relatie, typeAdres: TypeAdres): Filter<Adres> {
        if (relatie != null) {
            return new Filter<Adres>(fb => [fb.equal("relatieID",relatie.id), fb.equal("typeAdres",typeAdres)]);
        }
        else {
            return new Filter<Adres>(fb => [fb.equal("relatieID",-1)]);
        }
    }

    getPublicatieAdresFilter(relatie: Relatie): Filter<Adres> {
        
        if (relatie != null) {
            var TypeAdressen = [TypeAdres.Certificaat, TypeAdres.Overig];
            return new Filter<Adres>(fb => [fb.equal("relatieID",relatie.id), fb.isIn("typeAdres", TypeAdressen )]);
        }
        else {
            return new Filter<Adres>(fb => [fb.equal("relatieID",-1)]);
        }
    }

    getVerzendAdresFilter(relatie: Relatie): Filter<Adres> {
        
        if (relatie != null) {
            var TypeAdressen = [TypeAdres.Verzenden];
            return new Filter<Adres>(fb => [fb.equal("relatieID",relatie.id), fb.isIn("typeAdres", TypeAdressen )]);
        }
        else {
            return new Filter<Adres>(fb => [fb.equal("relatieID",-1)]);
        }
    }
}

export class AdresResponse {
    successful: boolean;
    relatieId: number;
    message: string;
}
